$(() => {
  const links = $('.js-link');
  if (!links.length) return;

  links.on('click', (e) => {
    const $link = $(e.currentTarget);
    const href = $link.data('href');
    const $target = $(e.target).closest('.js-link');

    // スマホ限定リンク
    if ($target.hasClass('js-link-on-sm')) {
      if ($('body').hasClass('smartphone')) window.location = href;
      return;
    }

    // PC限定リンク
    if ($target.hasClass('js-link-on-pc')) {
      if ($('body').hasClass('pc')) window.location = href;
      return;
    }

    // どちらでもOK
    window.location = href;
  });
});
